import { useEffect } from 'react';
import Plausible from 'plausible-tracker';

const plausible = Plausible({ domain: 'erledix.de' });

export function useScrollTracking() {
	const getScrollPercent = () => {
		const scrollTop =
			window.pageYOffset ||
			document.documentElement.scrollTop ||
			document.body.scrollTop ||
			0;

		const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

		const clientHeight = document.documentElement.clientHeight || window.innerHeight;

		return Math.round((scrollTop / (scrollHeight - clientHeight)) * 100);
	};

	useEffect(() => {
		// Wenn bereits in dieser Session gesendet, Hook beenden
		if (sessionStorage.getItem('scrollDepthTracked') === 'true') {
			return;
		}

		const handleScroll = () => {
			const scrollPercent = getScrollPercent();

			if (scrollPercent >= 25) {
				plausible.trackEvent('ScrollDepth', { props: { viewed_25_percent: true } });

				// Merker in der Session setzen -> nie wieder auslösen
				sessionStorage.setItem('scrollDepthTracked', 'true');

				// Listener entfernen, da er nicht mehr gebraucht wird
				window.removeEventListener('scroll', handleScroll);
			}
		};

		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);
}
